import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { toast } from 'sonner';

export const INVITE_USER_MUTATION = gql`
  mutation InviteUser($input: InviteUserInput!) {
    inviteUser(input: $input) {
      user {
        id
        email
        fullName
        role
        invitedAt
        createdAt
      }
    }
  }
`;

interface InviteUserResponse {
  inviteUser: {
    user: {
      id: string;
      email: string;
      fullName: string;
      role: string;
      invitedAt: string;
      createdAt: string;
    };
  };
}

export function useInviteUser(options?: { onCompleted?: () => void; onError?: (error: any) => void }) {
  const [inviteUserMutation, { loading }] = useMutation<InviteUserResponse>(INVITE_USER_MUTATION, {
    onCompleted: options?.onCompleted,
    onError: (error: any) => {
      if (options?.onError) {
        options.onError(error);
      } else {
        const message = error.graphQLErrors?.[0]?.message || error.message || 'Falha ao enviar convite';
        toast.error(message);
      }
    },
  });

  const inviteUser = (email: string, role?: string) => {
    return inviteUserMutation({
      variables: { input: { email, role } },
    });
  };

  return { inviteUser, loading };
}
